<nav class="navbar navbar-expand-lg navbar-light bg-primary mb-1">
  <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
    <span class="navbar-toggler-icon"></span>
  </button>
  <div class="collapse navbar-collapse" id="navbarNav">
    <ul class="navbar-nav">
      <li class="nav-item active">
        <a class="nav-link" routerLink="">Whitbey Bailie Properties LLC <span class="sr-only">(current)</span></a>
      </li>
      <li class="nav-item">
        <a class="nav-link" routerLink="properties">Properties <span class="sr-only">(current)</span></a>
      </li>
    </ul>
  </div>
</nav>
